"use client";

import QuotationStudio from "../components/QuotationStudio";

export default function QuotationTab() {
  return <QuotationStudio />;
}
